/* nos Largeサイズ・セール表示（2026-09 追加）
   1) data-nos-sale-window="開始-終了"（UNIX秒）を持つ要素を、閲覧時刻がセール期間内のときだけ表示する。
      data-nos-regular-window はその逆。Liquid の 'now' はページのキャッシュで古くなるため、ここで補正する。
   2) 価格付きプルダウン（.nos-pselect）:
      - select の変更をテーマ標準の radio に同期する（select 自身のリスナーで先に radio を切り替え、
        同じ change イベントが variant-options まで伝わってテーマ側の切替処理が走る）
      - カラット等が変わるたびに、各地金の価格をページ内のバリアント一覧から引き直す
        （セール期間中の Large は割引後の価格） */
(function () {
  'use strict';

  function inWindow(attr, now) {
    var parts = String(attr || '').split('-');
    var start = Number(parts[0]) || 0;
    var end = Number(parts[1]) || 0;
    return end > 0 && now >= start && now < end;
  }

  function gate(root) {
    var now = Date.now() / 1000;
    var changed = false;
    var scope = root || document;
    scope.querySelectorAll('[data-nos-sale-window]').forEach(function (el) {
      var on = inWindow(el.getAttribute('data-nos-sale-window'), now);
      if (el.hidden === on) {
        el.hidden = !on;
        changed = true;
      }
    });
    scope.querySelectorAll('[data-nos-regular-window]').forEach(function (el) {
      var on = inWindow(el.getAttribute('data-nos-regular-window'), now);
      if (el.hidden !== on) {
        el.hidden = on;
        changed = true;
      }
    });
    if (changed) document.dispatchEvent(new CustomEvent('nos:gate'));
  }

  function yen(subunits) {
    return '¥' + Math.round(subunits / 100).toLocaleString('ja-JP');
  }

  function initPriceSelect(fieldset) {
    if (fieldset.hasAttribute('data-nos-ready')) return;
    fieldset.setAttribute('data-nos-ready', '');

    var root = fieldset.closest('variant-options');
    var select = fieldset.querySelector('.nos-pselect__input');
    var nameEl = fieldset.querySelector('.nos-pselect__name');
    var priceEl = fieldset.querySelector('.nos-pselect__price');
    if (!root || !select) return;

    var radios = Array.prototype.slice.call(fieldset.querySelectorAll('input[type="radio"]'));
    var index = Number(fieldset.getAttribute('data-option-index')) || 0;
    var large = (fieldset.getAttribute('data-large') || '').split(',').filter(Boolean);
    var rate = Number(fieldset.getAttribute('data-sale-rate')) || 0;
    var variants = null;

    function variantList() {
      if (!variants) {
        var json = root.querySelector('script[type="application/json"]');
        try {
          variants = json ? JSON.parse(json.textContent) : [];
        } catch (e) {
          variants = [];
        }
      }
      return variants;
    }

    function currentOptions() {
      return Array.prototype.map.call(root.querySelectorAll('.wt-product__option'), function (option) {
        var checked = option.querySelector('input[type="radio"]:checked');
        return checked ? checked.value : '';
      });
    }

    function findVariant(values) {
      var list = variantList();
      for (var i = 0; i < list.length; i++) {
        var options = list[i].options || [];
        if (options.length !== values.length) continue;
        var match = true;
        for (var j = 0; j < options.length; j++) {
          if (options[j] !== values[j]) {
            match = false;
            break;
          }
        }
        if (match) return list[i];
      }
      return null;
    }

    function paint() {
      var option = select.options[select.selectedIndex];
      if (!option) return;
      nameEl.textContent = option.value;
      var price = option.getAttribute('data-price');
      priceEl.textContent = price ? yen(Number(price)) : '';
      priceEl.classList.toggle('is-sale', option.getAttribute('data-sale') === '1');
    }

    function refresh() {
      var values = currentOptions();
      var saleOn = rate > 0 && inWindow(fieldset.getAttribute('data-sale-window'), Date.now() / 1000);
      Array.prototype.forEach.call(select.options, function (option) {
        var combo = values.slice();
        combo[index] = option.value;
        var variant = findVariant(combo);
        if (!variant) {
          option.textContent = option.value;
          option.removeAttribute('data-price');
          option.setAttribute('data-sale', '0');
          return;
        }
        var price = variant.price;
        var isSale = false;
        if (saleOn && variant.compare_at_price > variant.price) {
          for (var k = 0; k < variant.options.length; k++) {
            if (large.indexOf(variant.options[k]) !== -1) {
              isSale = true;
              break;
            }
          }
          if (!(variant.compare_at_price > variant.price)) isSale = false; // 価格は商品データの割引後価格をそのまま使う
        }
        option.setAttribute('data-price', String(price));
        option.setAttribute('data-sale', isSale ? '1' : '0');
        option.textContent = option.value + '　' + yen(price);
      });
      var checked = fieldset.querySelector('input[type="radio"]:checked');
      if (checked && select.value !== checked.value) select.value = checked.value;
      paint();
    }

    select.addEventListener('change', function () {
      for (var i = 0; i < radios.length; i++) {
        if (radios[i].value === select.value) {
          radios[i].checked = true;
          break;
        }
      }
      paint();
    });
    root.addEventListener('variantChangeEnd', refresh);
    document.addEventListener('nos:gate', refresh);
    refresh();
  }

  function watchPriceBlocks() {
    if (!('MutationObserver' in window)) return;
    document.querySelectorAll('[id^="price-"]').forEach(function (wrap) {
      new MutationObserver(function () {
        gate(wrap);
      }).observe(wrap, { childList: true, subtree: true });
    });
  }

  function init() {
    gate(document);
    document.querySelectorAll('.nos-pselect').forEach(initPriceSelect);
    watchPriceBlocks();
    setInterval(function () {
      gate(document);
    }, 30000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
